import reactImageSize from './src/reactImageSize';

export default reactImageSize;
